import { createPortal } from 'react-dom'

interface DirectoryConfirmDialogProps {
  open: boolean
  title: string
  description?: string
  confirmLabel?: string
  confirmTone?: 'danger' | 'default'
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export default function DirectoryConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  confirmTone = 'danger',
  busy = false,
  onConfirm,
  onCancel,
}: DirectoryConfirmDialogProps) {
  if (!open) return null
  if (typeof document === 'undefined') return null

  const confirmClass =
    confirmTone === 'danger'
      ? 'bg-terracotta text-white hover:bg-terracotta/90'
      : 'bg-cocoa text-white hover:bg-cocoa/90'

  return createPortal(
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-lg">
        <div className="space-y-2">
          <h3 className="text-lg font-semibold text-cocoa">{title}</h3>
          {description ? <p className="text-sm text-cocoa/70">{description}</p> : null}
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            className="rounded-full border border-cocoa/20 bg-white px-4 py-1.5 text-sm font-medium text-cocoa hover:bg-shell/50 disabled:opacity-60"
            onClick={onCancel}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition disabled:opacity-60 ${confirmClass}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
